import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OktaAuthService } from '@services/_iam/okta-auth.service';

/**
 * Custom replacement for @okta/okta-angular's OktaCallbackComponent.
 *
 * The library's OktaCallbackComponent only calls handleLoginRedirect() and,
 * on failure, just renders the raw error string with no recovery — which is
 * why users could get stuck on a blank page showing:
 * "AuthSdkError: Could not load PKCE codeVerifier from storage...".
 *
 * This component delegates to OktaAuthService.handleCallback(), which
 * catches that error (single-use /authorize URL replayed, e.g. via
 * copy/paste, browser back/forward, or a bookmark) and automatically starts
 * a fresh sign-in flow instead of leaving the user stranded.
 */
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-okta-callback',
  template: `<div></div>`,
})
export class OktaCallbackComponent implements OnInit {
  constructor(private oktaAuthService: OktaAuthService) {}

  ngOnInit(): void {
    this.oktaAuthService.handleCallback();
  }
}
